import { useEffect } from 'react';

import {
  useCollectionStore,
  type CollectionViewOptions,
} from '$/stores/useCollectionStore';

export const useCollectionViewOptions = () => {
  const activeType = useCollectionStore.useActiveType();
  const activeViewMode = useCollectionStore.useSelectedViewMode();
  const appliedFilter = useCollectionStore.useAppliedFilterOptions();

  const hasCollectionFilter =
    activeType === 'color_tint' &&
    appliedFilter.filter((option) => option.option === 'collection').length > 0;

  useEffect(() => {
    if (!hasCollectionFilter && activeViewMode === 'fan') {
      useCollectionStore.setState({ selectedViewMode: 'grid' });
    }
  }, [activeViewMode, hasCollectionFilter]);

  type Option = {
    name: CollectionViewOptions;
    isVisible: boolean;
  };

  const options: Option[] = [
    {
      name: 'grid',
      isVisible: true,
    },
    {
      name: 'fan',
      isVisible: hasCollectionFilter && activeType === 'color_tint',
    },
    {
      name: 'list',
      isVisible: true,
    },
  ];

  if (!activeType) return [];
  return options.filter((option) => option.isVisible);
};
